// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';

import TreeItemDir from './TreeItemDir.jsx';
import App, {get_state_collect} from './App.jsx';

import {noop, scroll} from './utils.js';
import {fetch_collects} from './fetch_things.js';
import {T_CULTI} from './codtype.js';

import type {T_Next, T_Item, T_CollectFolder} from './types.js';
import type {TreeItem} from './TreeItem.js';



type T_TreeItemCollectProps = {
  node       : T_Item,
  indent     : number,
  parent_item: TreeItemDir,
  disabled   : boolean,
  app        : App
};



type T_TreeItemCollectState = {
  Loaded: boolean
};




export default class TreeItemCollect extends Component<T_TreeItemCollectProps, T_TreeItemCollectState> implements TreeItem {
  state = {
    Loaded: false
  };
  
  
  
  get_path(): string {
    return this.props.node.Path;
  }
  
  
  
  get_file(): string {
    return this.props.node.File;
  }
  
  
  
  open(next: T_Next = noop): void {
    const {app} = this.props;
    
    if (app.item_collect !== null) {
      return;
    }
    
    if (this.state.Loaded) {
      return next(false);
    }
    
    fetch_collects(app, this.props.node.Path, (response: string | T_CollectFolder): void => {
      if (typeof response === 'string') {
        Alert.error(response);
        return next(false);
      }
      
      const end = () => this.setState({Loaded: true}, () => {
        app.setState(get_state_collect(col), () => {
          app.item_collect = this;
          
          next(true);
        });
      });
      
      const col = (response: T_CollectFolder),
            item_culti = this.props.parent_item.shps.find(ishp => ishp.props.node.Cod === T_CULTI);
      
      if (item_culti && ! app.map_ui.map.is_loaded(item_culti.props.node.Path)) {
        if (item_culti != null) {
          item_culti.toggle(end);
        }
      }
      else if (app.toolbar != null && item_culti != null && app.toolbar.state.culti !== item_culti.props.node.Path) {
        app.map_ui.change_culti(item_culti.props.node.Path, end, false, true);
      }
      else {
        end();
      }
    });
  }
  
  
  
  close(next: T_Next = noop): void {
    if (! this.state.Loaded) {
      return next(false);
    }
    
    const {app} = this.props;
    
    this.setState({Loaded: false}, () => {
      app.setState(get_state_collect(null), () => {
        app.item_collect = null;
        
        next(true);
      });
    });
  }
  
  
  
  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }
    
    if (! this.state.Loaded) {
      this.open(next);
    }
    else {
      this.close(next);
    }
  }
  
  
  
  click = (ev: SyntheticMouseEvent<*>): void => {
    ev.stopPropagation();
    
    if (!this.props.node.Path.includes('/Bayer')) {
      if (ev.button === 0) {
        this.toggle();
      }
    }
  };
  
  
  
  rclick = (ev: SyntheticMouseEvent<*>): void => {};
  
  
  
  refresh(next: T_Next = noop): void {
    const Loaded = this.props.app.map_ui.map.is_loaded(this.props.node.Path);
    
    if (Loaded !== this.state.Loaded) {
      const new_state = {Loaded};
      
      this.setState(new_state, () => next(true));
    }
    else {
      next(false);
    }
  }
  
  
  
  scroll(): void {
    this.props.parent_item.open_parents(() => {
      scroll(ReactDOM.findDOMNode(this));
    });
  };
  
  
  
  unclick(): void {
    if (this.state.Loaded) {
      this.setState({Loaded: false});
    }
  }
  
  
  
  render() {
    const {Loaded} = this.state,
          lb_style = {fontWeight: Loaded ? 'bold' : 'normal', color: 'black', border: '0', paddingRight: 0, paddingLeft: 0},
          indent = {marginLeft: 15 * this.props.indent};
    
    return (
      <div>
        <div style={indent} className='treeItem' onClick={this.click} onContextMenu={this.rclick}>
          <Icon name={Loaded ? 'check-square-o' : 'square-o'} />
          
          <span style={lb_style}>
            {this.props.node.label}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemCollect.jsx